import React, { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'melanua_cookie_consent';

// Initialize Google Analytics
function loadGoogleAnalytics() {
  if (window.gtag) return; // Already loaded

  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-TFJ3FKB2FH';
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', 'G-TFJ3FKB2FH', { 'send_page_view': true, 'transport_type': 'beacon' });
}

// Check if user has already consented
export function hasConsented() {
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  return consent === 'accepted';
}

// Initialize analytics if user has already consented
export function initConsentBasedAnalytics() {
  if (hasConsented()) {
    loadGoogleAnalytics();
  }
}

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay before showing banner for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
        setTimeout(() => setIsAnimating(true), 50);
      }, 1500);
      return () => clearTimeout(timer);
    } else if (consent === 'accepted') {
      // Load GA if previously accepted
      loadGoogleAnalytics();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    loadGoogleAnalytics();
    setIsAnimating(false);
    setTimeout(() => setIsVisible(false), 300);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setIsAnimating(false);
    setTimeout(() => setIsVisible(false), 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${
        isAnimating ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-white border-t border-gray-200 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            {/* Text Content */}
            <div className="flex-1 text-center sm:text-left">
              <p className="text-sm text-gray-700">
                We use cookies to enhance your experience and analyze site traffic.
                By clicking "Accept", you consent to our use of cookies.{' '}
                <a
                  href="/privacy-policy/"
                  className="text-melanua-gold hover:underline font-medium"
                >
                  Learn more
                </a>
              </p>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={handleDecline}
                className="px-5 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
              >
                Decline
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-2 text-sm font-medium text-white bg-melanua-gold hover:bg-melanua-gold/90 rounded transition-colors"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
